<template>
  <div style="margin-top: 30px; padding:11px;">
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
      Yönetim Gideri Ekle
    </button>
    <br>
    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
        <tr>
          <td><b>Yönetim Gideri</b></td>
          <td><b>İşlemler</b></td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="val in CompanyManagementExpenseData" :key="val.id">
          <td><b>{{ formatCurrency(val.companyManagementExpense) }}</b></td>
          <td>
            <button type="button" class="btn btn-danger"
                    data-bs-toggle="modal"
                    data-bs-target="#companyDeleteModal"
                    @click="setDeleteId(val.id)">Sil</button>
            &nbsp;
            <button type="button" class="btn btn-secondary"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    @click="editExpense(val)">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Silme Modalı -->
    <div class="modal fade" id="companyDeleteModal" tabindex="-1" aria-labelledby="companyDeleteModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="companyDeleteModalLabel">Silme Onayı</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Bu öğeyi silmek istediğinizden emin misiniz?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">İptal</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="SeniorityBurdenDelete(deleteId)">
              Evet, Sil
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Ekleme ve Düzenleme Modalı -->
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content" style="min-height: 500px; width: 750px;">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ isEditing ? 'Yönetim Gideri Düzenle' : 'Yönetim Gideri Ekle' }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">
            <div class="mb-3">
              <label for="companyManagementExpenseInput" class="form-label">Yönetim Gideri</label>
              <input type="number" class="form-control" id="companyManagementExpenseInput" v-model="itemsCompanyManagementExpense.companyManagementExpense" placeholder="Yönetim Gideri" min="0" step="0.01">
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="isEditing ? updateExpense() : SeniorityCeilingSave()">
              {{ isEditing ? 'Güncelle' : 'Kaydet' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck
import apiClient from "@/axios";

export default {
  name: "CompanyManagementExpense",
  data() {
    return {
      CompanyManagementExpenseData: [],
      deleteId: null,
      isEditing: false,  // Düzenleme modunu kontrol etmek için
      itemsCompanyManagementExpense: {
        companyManagementExpense: null,
        id: null,  // Güncelleme için ID ekledik
      },
    };
  },
  created() {
    this.getCompanyManagementExpenseData();
  },
  methods: {
    // Yönetim Gideri Kaydet
    SeniorityCeilingSave() {
      apiClient.post("/companyManagementExpense", this.itemsCompanyManagementExpense).then(() => {
        this.getCompanyManagementExpenseData();
        this.itemsCompanyManagementExpense = { companyManagementExpense: null };
      }).catch(error => {
        console.error("Kaydetme işlemi sırasında hata oluştu:", error);
      });
    },

    // Veri Getir
    getCompanyManagementExpenseData() {
      apiClient.get("/companyManagementExpense").then(res => {
        this.CompanyManagementExpenseData = res.data;
      }).catch(error => {
        console.error("Veri çekme işlemi sırasında hata oluştu:", error);
      });
    },

    // Silme ID'sini Ayarlama
    setDeleteId(id) {
      this.deleteId = id;
    },

    // Silme işlemi
    SeniorityBurdenDelete(id) {
      apiClient.delete(`/companyManagementExpense/${id}`).then(() => {
        this.getCompanyManagementExpenseData();
      }).catch(error => {
        console.error("Silme işlemi sırasında hata oluştu:", error);
      });
    },

    // Formatlı para birimi döndürme
    formatCurrency(value) {
      if (value !== undefined && value !== null) {
        return new Intl.NumberFormat("tr-TR", {
          style: "currency",
          currency: "TRY",
        }).format(value);
      }
      return "₺0,00";
    },

    // Düzenleme işlemi için modalı açma
    editExpense(expense) {
      this.itemsCompanyManagementExpense = {
        companyManagementExpense: expense.companyManagementExpense,
        id: expense.id,
      };
      this.isEditing = true;
    },

    // Güncelleme işlemi
    updateExpense() {
      apiClient.put(`/companyManagementExpense/${this.itemsCompanyManagementExpense.id}`, this.itemsCompanyManagementExpense).then(() => {
        this.getCompanyManagementExpenseData();
        this.isEditing = false;
        this.itemsCompanyManagementExpense = { companyManagementExpense: null };
      }).catch(error => {
        console.error("Güncelleme işlemi sırasında hata oluştu:", error);
      });
    },
  },
};
</script>

<style scoped>
</style>
